<template>
  <textarea
    v-model="currentValue"
    :class="['form-control', 'ignore']"
    :placeholder="placeholder"
    @input="onInput"
  ></textarea>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$el.style.height = this.$el.scrollHeight + 'px';
    });

    this.$el.addEventListener('input', this.resize);
  },
  beforeDestroy() {
    this.$el.removeEventListener('input', this.resize);
  },
  methods: {
    resize(event) {
      event.target.style.height = 'auto';
      event.target.style.height = event.target.scrollHeight + 'px';
    },
    onInput() {
      this.$emit('input', this.currentValue);
    }
  }
};
</script>
